import { Module } from 'vuex-smart-module';
import VideosActions from './actions';
import VideosGetters from './getters';
import VideosMutations from './mutations';
import VideosState from './state';

export default new Module({
  state: VideosState,
  mutations: VideosMutations,
  actions: VideosActions,
  getters: VideosGetters,
});
